module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-06.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-06.png
// module id = 1381
// module chunks = 0